import React from 'react';
import { Polyline, CircleMarker, Popup } from 'react-leaflet';

const RouteLayer = ({ routes, activeRouteIds }) => {
  const isFleetRouteActive = (routeId) => {
    const key = String(routeId);
    if (!activeRouteIds) return true;
    if (Array.isArray(activeRouteIds)) return activeRouteIds.includes(key);
    return activeRouteIds.has(key);
  };

  // Ensure fallback (default) routes are rendered first so active routes render on top
  const sortedRoutes = [...(routes || [])].sort((a, b) => {
    const aFallback = !!a.isFallback;
    const bFallback = !!b.isFallback;
    if (aFallback === bFallback) return 0;
    return aFallback ? -1 : 1; // fallback first, active after
  });

  return (
    <>
      {sortedRoutes.map((route) => (
        <React.Fragment key={route.trip_id || route.id}>
          {(() => {
            const isFleet = route && route.isFleet === true;
            const isActive = isFleet ? isFleetRouteActive(route.id) : true;
            const routeColor = isActive ? (route.color || '#666666') : '#D3D3D3';
            const stopsFill = isActive ? (route.color || '#666666') : '#D3D3D3';

            const routeKey = String(route.trip_id || route.id);
            const activeKey = isActive ? 'on' : 'off';

            return (
              <>
          {/* Render route path */}
          {route.coordinates && route.coordinates.length > 0 && (
            <Polyline
              key={`${routeKey}-path-${activeKey}`}
              positions={route.coordinates}
              pathOptions={{
                color: routeColor,
                weight: 4,
                opacity: 0.8
              }}
            >
              <Popup>
                <div>
                  <strong>{route.name}</strong>
                  <br />
                  Route: {route.id}
                  {route.trip_id && (
                    <>
                      <br />
                      Trip: {route.trip_id}
                    </>
                  )}
                  <br />
                  <small>{route.coordinates.length} coordinate points</small>
                </div>
              </Popup>
            </Polyline>
          )}
          
          {/* Render stops as small circles */}
          {route.stops && route.stops.map((stop, index) => (
            <CircleMarker
              key={`${routeKey}-stop-${stop.stop_id || index}-${activeKey}`}
              center={[stop.stop_lat, stop.stop_lon]}
              radius={4}
              pathOptions={{
                color: '#ffffff',
                weight: 1,
                opacity: 1,
                fillColor: stopsFill,
                fillOpacity: 0.8
              }}
            >
              <Popup>
                <div>
                  <strong>{stop.stop_name}</strong>
                  <br />
                  Stop ID: {stop.stop_id}
                  {stop.stop_sequence && (
                    <>
                      <br />
                      Sequence: {stop.stop_sequence}
                    </>
                  )}
                  <br />
                  <small>
                    Position: {stop.stop_lat.toFixed(6)}, {stop.stop_lon.toFixed(6)}
                  </small>
                </div>
              </Popup>
            </CircleMarker>
          ))}
              </>
            );
          })()}
        </React.Fragment>
      ))}
    </>
  );
};

export default RouteLayer;
